import React from "react";
import styles from "./styles/TextArea.module.css";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import clsx from "clsx";

const TextArea = ({
  name,
  label,
  required,
  readonly,
  placeholder,
  rows,
  value,
  onChange,
  onBlur,
  autoComplete,
  touchedValue,
  errorsValue,
  maxLength,
  note,
  className,
}) => {
  return (
    <div className={styles.textAreaController}>
      <div className={clsx("form-group", styles.formContainer, className)}>
        {label ? (
          <Form.Label>
            {label}
            {required ? <span className="text-danger"> *</span> : null}
          </Form.Label>
        ) : null}
        <Form.Control
          name={name}
          disabled={readonly}
          as={"textarea"}
          placeholder={placeholder}
          rows={rows}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          autoComplete={autoComplete}
          isInvalid={touchedValue && errorsValue}
          maxLength={maxLength !== 0 ? maxLength : null}
        />
        <span className={styles.notiText}>{note ? note : ""}</span>
        <Form.Control.Feedback type="invalid" className="text-left">
          {errorsValue}
        </Form.Control.Feedback>
      </div>
    </div>
  );
};

/* required: display name */
TextArea.displayName = "TextArea";

/* required: props types */
TextArea.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  readonly: PropTypes.bool,
  placeholder: PropTypes.string,
  rows: PropTypes.number,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  touchedValue: PropTypes.bool.isRequired,
  errorsValue: PropTypes.string.isRequired,
  autoComplete: PropTypes.oneOf(["on", "off"]),
  maxLength: PropTypes.number,
  note: PropTypes.string,
};

/* required: default props */
TextArea.defaultProps = {
  label: "",
  required: false,
  readonly: false,
  placeholder: "Write something...",
  rows: 3,
  value: "",
  onChange: () => {},
  onBlur: () => {},
  touchedValue: false,
  errorsValue: "",
  autoComplete: "off",
  maxLength: 500,
  note: "",
};

export { TextArea };
